import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../../../core/services/api.config';
import { CaseStatusFilter, DatePreset, ReportResult, ReportType } from './report-types';

export interface RunReportQuery {
  datePreset: DatePreset;
  startDate?: string;
  endDate?: string;
  status?: CaseStatusFilter;
  partnerOrganizationId?: number | null;
  serviceName?: string | null;
}

export interface RunReportResponse extends ReportResult {
  reportType: ReportType;
  totalRows: number;
  appliedFilters: {
    datePreset: DatePreset;
    startDate: string;
    endDate: string;
    status?: CaseStatusFilter;
    partnerOrganizationId?: number | null;
    serviceName?: string | null;
  };
}

@Injectable({
  providedIn: 'root',
})
export class ReportsApiService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);

  runReport(reportType: ReportType, query: RunReportQuery): Observable<RunReportResponse> {
    let params = new HttpParams().set('datePreset', query.datePreset);

    if (query.startDate) {
      params = params.set('startDate', query.startDate);
    }

    if (query.endDate) {
      params = params.set('endDate', query.endDate);
    }

    if (query.status) {
      params = params.set('status', query.status);
    }

    if (query.partnerOrganizationId && query.partnerOrganizationId > 0) {
      params = params.set('partnerOrganizationId', String(query.partnerOrganizationId));
    }

    if (query.serviceName?.trim()) {
      params = params.set('serviceName', query.serviceName.trim());
    }

    return this.http.get<RunReportResponse>(`${this.apiBaseUrl}/reports/${reportType}`, {
      params,
      withCredentials: true,
    });
  }
}
